/**
 * 四舍五入两个小数，然后向上取整
 * @param num
 * @returns {*}
 */
export default (num) => {
    if(isNaN(num)){
        return 0
    }else {
        return Math.ceil(Math.round(num * 100) / 100)
    }
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/roundAndCeil.js